import ShDividerLine from '@/components/Helpers/ShDividerLine';
import EmptyListOnStartup from '@/components/Common/EmptyListOnStartup';
import AddNewElementButton from '@/components/Common/AddNewElementButton';
import WidgetsListItem from './WidgetsListItem';

// @vue/component
export default {
  name: 'WidgetsList',

  components: {
    ShDividerLine,
    WidgetsListItem,
    EmptyListOnStartup,
    AddNewElementButton,
  },

  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    possibleNumberOfWidgetAccordingToAccessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'].global_options.number_of_widgets;
    },
    isWaitingForWidgetsList() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'widgets/getList', 'widgets/delete',
      ]);
    },
    isEmpty() {
      return this.widgetsList.length === 0;
    },
    widgetsList() {
      return this.$store.getters['widgets/list'];
    },
  },

  created() {
    this.$store.dispatch('widgets/getList');
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
  },

  methods: {
    async handleCreateNewWidget() {
      const newWidgetId = await this.$store.dispatch('widgets/create');
      this.$router.push({ name: 'WidgetDetails', params: { id: newWidgetId } });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
